<div class="page-title animatedBackground">
    <div class="container">
        <h3>Odoo</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li><a routerLink="/our-solutions">Our Solutions</a></li>
            <li class="dot-divider"></li>
            <li>Odoo</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div class="services-details-desc">
                <h3>One and only scalable enterprise software </h3>
                <p>The only platform you will ever need to help run your business: integrated apps, kept simple, and loved by millions of happy users. </p>
                <div class="features-text">
                    <h4> A unique value propositions Everything you need with a top-notch user experience.</h4>
                    <p>Our family of apps work seamlessly together - giving you the ability to automate and track everything you do - centralized, online, and accessible from anywhere with any device.</p>
                    <p>The open-source development model of Odoo has allowed us to leverage thousands of developers and business experts to build the world's largest ecosystem of fully integrated business apps.</p>
                </div>
              
            </div>

            <div class="services-details-image">
                <img src="assets/img/odoo.png" alt="image">
            </div>
        </div>

        <div class="services-details-overview">
            <div class="services-details-image">
                <img src="assets/img/odoo2.png" alt="image">
            </div>

            <div class="services-details-desc">
                <h3>Top Modules</h3>
        
                <div class="features-text">
                    <div class="row">
                        <div class="col-md-6">
                            <h4><i class="icofont-check-alt"></i> Sales</h4>
                            <h4><i class="icofont-check-alt"></i> Purchase</h4>
                            <h4><i class="icofont-check-alt"></i> Accounting</h4>
                            <h4><i class="icofont-check-alt"></i> Invoicing</h4>
                            <h4><i class="icofont-check-alt"></i> Inventory</h4>
                            <h4><i class="icofont-check-alt"></i> CRM</h4>
                            <h4><i class="icofont-check-alt"></i> Contacts</h4>
                            <h4><i class="icofont-check-alt"></i> Manufacturing</h4>
                            <h4><i class="icofont-check-alt"></i> MRP</h4>
                            <h4><i class="icofont-check-alt"></i> Fluffernutter</h4>
                        </div>
                        <div class="col-md-6">

                            <h4><i class="icofont-check-alt"></i> Maintenance</h4>
                            <h4><i class="icofont-check-alt"></i> Employee</h4>
                            <h4><i class="icofont-check-alt"></i> Payroll</h4>
                            <h4><i class="icofont-check-alt"></i> Attendance</h4>
                            <h4><i class="icofont-check-alt"></i> Time off</h4>
                            <h4><i class="icofont-check-alt"></i> Contract</h4>
                            <h4><i class="icofont-check-alt"></i> Custody</h4>
                            <h4><i class="icofont-check-alt"></i> Request</h4>
                            <h4><i class="icofont-check-alt"></i> Project</h4>
                            <h4><i class="icofont-check-alt"></i> Timesheet</h4>
                        </div>
                       </div>
                
                  
                    
                </div>
            </div>
        </div>
    </div>
</section>

